<template>
  <div ref="watermark" class="watermark-container" v-if="showWatermark"></div>
</template>

<script>
  import { debounce } from 'lodash'; // 引入 lodash 的 debounce 函数
  
  export default {
    name: 'Watermark',
    props: {
      text: {
        type: String,
        required: false,
        default: '',
      },
    },
    data() {
      return {
        showWatermark: true,
        angle: -20,
        fontSize: '20px',
        fontColor: 'rgba(200, 200, 200, 0.50)',
        fontFamily: 'Arial',
        watermarkLength: 400, // 水印的长度
        timerId: null, // 定时器ID
      };
    },
    methods: {
      addWatermark() {
        // 名字加上时间
        const date = new Date(this.$store.state.timestamp).toISOString().substring(0, 10); // 使用 ISO 格式简化日期获取
        const textInfo = this.text + ' ' + date;
        
        const watermarkDiv = this.$refs.watermark;
        const canvas = document.createElement('canvas');
        
        // 创建 canvas 上下文
        const ctx = canvas.getContext('2d');
        
        // 测量文本的实际宽度
        ctx.font = `${this.fontSize} ${this.fontFamily}`;
        const textWidth = ctx.measureText(textInfo).width;
        
        // 根据文本宽度和水印长度来确定 canvas 的宽度
        const canvasWidth = Math.max(textWidth, this.watermarkLength);
        
        canvas.width = canvasWidth;
        canvas.height = 250;
        
        // 旋转画布
        ctx.rotate(this.angle * Math.PI / 180);
        
        // 设置字体样式
        ctx.font = `${this.fontSize} ${this.fontFamily}`;
        ctx.fillStyle = this.fontColor;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        
        // 计算文本的 x 坐标，确保文本居中显示
        const x = canvas.width / 2;
        const y = canvas.height / 2;
        
        // 绘制文本
        ctx.fillText(textInfo, x, y);
        
        // 设置水印背景图像
        watermarkDiv.style.backgroundImage = `url(${canvas.toDataURL('image/png')})`;
        watermarkDiv.style.pointerEvents = 'none';
        watermarkDiv.style.position = 'fixed';
        watermarkDiv.style.top = 0;
        watermarkDiv.style.left = 0;
        watermarkDiv.style.width = '100%';
        watermarkDiv.style.height = '100%';
        watermarkDiv.style.zIndex = 9999;
      },
      clearWatermark() {
        // 清除水印
        this.$refs.watermark.style.backgroundImage = '';
      },
      startTimer() {
        this.timerId = setInterval(() => {
          if (this.showWatermark) {
            this.addWatermark();
          }
        }, 1800000); // 每半小时更新一次
      },
      stopTimer() {
        clearInterval(this.timerId);
      },
    },
    mounted() {
      this.addWatermark();
      this.startTimer();
    },
    beforeDestroy() {
      this.stopTimer();
    },
    watch: {
      showWatermark(newVal) {
        if (newVal) {
          this.addWatermark();
        } else {
          this.clearWatermark();
        }
      },
      watermarkLength: debounce(function (newVal) {
        if (this.showWatermark) {
          this.addWatermark();
        }
      }, 200),
      text: debounce(function (newVal) {
        if (this.showWatermark) {
          this.addWatermark();
        }
      }, 200),
      angle: debounce(function (newVal) {
        if (this.showWatermark) {
          this.addWatermark();
        }
      }, 200),
      fontSize: debounce(function (newVal) {
        if (this.showWatermark) {
          this.addWatermark();
        }
      }, 200),
      fontColor: debounce(function (newVal) {
        if (this.showWatermark) {
          this.addWatermark();
        }
      }, 200),
      fontFamily: debounce(function (newVal) {
        if (this.showWatermark) {
          this.addWatermark();
        }
      }, 200),
    },
  };
</script>

<style scoped>
  .watermark-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 9999;
  }
</style>
